// This icon file is generated automatically.
var PSwapLeftOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 12 12", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M11.63 6.94H2.16l2.25-2.86c.07-.08.01-.2-.1-.2h-1a.5.5 0 00-.4.19L.36 7.32a.5.5 0 00.39.8h10.88c.06 0 .12-.05.12-.12v-.94a.13.13 0 00-.13-.12z", "fill-rule": "nonzero" } }] }, "name": "p-swap-left", "theme": "outlined" };
export default PSwapLeftOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PSwapLeftOutlined.js
// module id = 3662
// module chunks = 0